import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

import { ProductionAreaOverrideModal } from './production-area-override.modal';
import { ProductionAreaOverrideModalService } from 'src/app/modals/pos-manager/production-area-override/production-area-override-modal.service';

@NgModule({
  declarations: [ProductionAreaOverrideModal],
  imports: [CommonModule, IonicModule, NgSelectModule, ReactiveFormsModule, TranslocoModule],
  exports: [ProductionAreaOverrideModal],
  providers: [ProductionAreaOverrideModalService]
})
export class ProductionAreaOverrideModalModule {}
